<script lang="ts">
import { computed } from 'vue';

export type ContainerSize =
  | 'xs'
  | 'sm'
  | 'md'
  | 'xl'
  | '2xl'
  | 'deprecated_768'
  | 'deprecated_1200'
  | 'deprecated_1600';
</script>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    /** Deprecated sizes willen we uitfaseren. Gebruik deze dus NIET voor nieuwe situaties. */
    size?: ContainerSize;
  }>(),
  {
    size: 'md',
  },
);

const sizeClasses = {
  deprecated_768: 'max-w-[768px]',
  deprecated_1200: 'max-w-[1200px]',
  deprecated_1600: 'max-w-[1600px]',
  xs: 'max-w-[480px]',
  sm: 'max-w-[1046px]',
  md: 'max-w-[1328px]',
  xl: 'max-w-[1600px]',
  '2xl': 'max-w-[1920px]',
} as const;

const sizeClass = computed(() => sizeClasses[props.size]);
</script>
<template>
  <div :class="['mx-auto box-content w-[calc(100%-3rem)] grow px-4 lg:px-6', sizeClass]">
    <slot></slot>
  </div>
</template>
